const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  pay ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/kkren-jyorder/pay', params, {
      noShowError: true,
    })
  },
  payMessy ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/kkren-jyorder/pay-messy', params)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
